export default function (store, from, to) {
  console.log(from.path + ' -> ' + to.path)
  store.dispatch('updateCurrentPath', to.path)
}
